module.exports = "/_next/static/images/lu-229c065684de9be295a6161caaa067ec.svg";